// These are to enforce the field "name" property and keep everything typed
export var objectSchemaKey = 'objectSchema';
export var aqlKey = 'aql';